module.exports = __webpack_public_path__ + "static/real-reviews-ee7ffb7d8da0d7040593401b8d060cf8.svg";